import { render, staticRenderFns } from "./CCascaderK.vue?vue&type=template&id=5454dacc&scoped=true"
import script from "./CCascaderK.vue?vue&type=script&lang=js"
export * from "./CCascaderK.vue?vue&type=script&lang=js"
import style0 from "./CCascaderK.vue?vue&type=style&index=0&id=5454dacc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5454dacc",
  null
  
)

export default component.exports